import { useMutation } from 'react-query'
import { SUCCESS_RESPONSE_TYPE } from 'api/constants'
import { UseMutationOptions } from 'react-query/types/react/types'
import { sendToApi } from 'api/client'
import { buildErrorMessage } from 'utils'

interface Variables {
  scheduleId: number
}

export type Options = Omit<UseMutationOptions<void, Error, Variables>, 'mutationFn'>

export const generateTheme = async ({ scheduleId }: Variables) => {
  const res = await sendToApi<void>(`/schedules/${scheduleId}/generate_theme`, {
    method: 'POST',
  })

  if (res.type !== SUCCESS_RESPONSE_TYPE) {
    throw new Error(buildErrorMessage(res.data?.errors) || 'An error occurred generating the theme.')
  }

  return res.data
}

export const useGenerateTheme = (options?: Options) => {
  return useMutation<void, Error, Variables>(generateTheme, options)
}
